import React from 'react'

export const ProfileItem = ({item}) => {
    // let {name,title,description,symbol}: any = switchName(item.type)
    return (
        <li>
              <div>
                <h3 className="title">{item.name}</h3>
                <p></p>
                <ul className="">
                    {item?.sector?.length && ( <li><b>Sector: </b><p>{ item?.sector[0]?.title }</p></li> )}
                    {item?.city?.length && ( <li><b>City: </b><p>{ item?.city[0]?.name }</p></li> )}
                    
                    {/* <li>{title} {item.sector.map((sector,i)=>i==0 && `${sector}` )}</li> */}
                    {/* {item.job &&  <li>{description} {item.job.map((job,i)=>i==item.job.length-1? job : `${job}, ` )}</li>} */}
                    {/* {item.position &&  <li>{description} {item.position.map((position,i)=>i==item.position.length-1? position : `${position}, ` )}</li>} */}
                </ul>
            </div>
            <div>
                <div className="button"  onClick={(e ) =>{
                        e.preventDefault()
                    }}>
                    View
                </div>
            </div>
        </li>
    )
}